import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/app.css'
import VueKinesis from "vue-kinesis";
import VueGtag from "vue-gtag";

createApp(App).use(store).use(router).use(VueKinesis).use(VueGtag, {
    config: { id: "G-HJ7QBG8L3M" }
}).mount('#app');